import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { forkJoin, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { MatTab, MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { PurchaseExecutives } from 'src/app/shared/models/database-models/PurchaseExecutives.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { UserInformation } from 'src/app/shared/models/app-models';
import { Store } from '@ngrx/store';
import { MyWorkListData, MyWorklist } from 'src/app/shared/models/database-models/MyWorklist.model';
@Component({
  selector: 'app-my-worklist',
  templateUrl: './my-worklist.component.html',
  styleUrls: ['./my-worklist.component.scss']
})
export class WorklistPageComponent implements OnInit, OnDestroy {

  destroy$: Subject<boolean> = new Subject<boolean>();
  selectedIndex: number = 0;
  selectedButton : string = 'worklist'
  loggedInUser!: UserInformation
  isUserPE: boolean = false;
  isDataLoaded: boolean = false;
  @ViewChild("formTabs") matTab!: MatTab;
  workListTabs = [
    { label: 'Pending', badge: 0, data: [] as MyWorklist[] },
    { label: 'Completed', badge: 0, data: [] as MyWorklist[] },
  ];
  constructor(
    private router: Router,
    private backendService: BackendApiService,
    private store: Store<{  user: UserInformation }>,
  ) {
    this.selectedButton = this.router.url.split('/')[1];
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
      this.loggedInUser = user;
      if(this.loggedInUser.userName){
        this.loadGetPurchaseExecutivesList()
        this.loadAllData();
      }
      
    })
  }

  async ngOnInit(): Promise<void> {
  }

  loadAllData() {
    const countRequests = this.workListTabs.map(tab =>
      this.backendService.getDocumentsForAO(
        this.loggedInUser.userName,
        tab.label,
        '20',
        '1',
        null,
        null
      )
    );

    forkJoin(countRequests).subscribe({
      next: (responses: MyWorkListData[]) => {
        responses.forEach((data, index) => {
          this.workListTabs[index].data = data.documents;
          this.workListTabs[index].badge = data.totalCount;
        });
      },
      error: (err) => {
        console.error('Error fetching worklist data:', err);
        this.isDataLoaded = true;
      },
      complete: () => {
        console.log('All Tabs worklist loaded successfully.');
        this.isDataLoaded = true;
      }
    });
  }

  async loadGetPurchaseExecutivesList() {
    let data: PurchaseExecutives[];
    data = await lastValueFrom(this.backendService.getPurchaseExecutivesList(this.loggedInUser.userName))
    this.isUserPE = data.length >= 1 ? true : false 
  }
  onSelectedIndexChange(event: number) {
    // set selectedIndex for the tabs
    this.selectedIndex = event;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onWorklistChange(event: any) {
    this.selectedButton = event.value;
    if(event.value === 'peworklist'){
      this.router.navigateByUrl('/peworklist');
    }else{
      this.router.navigateByUrl('/worklist');
    }
  }
}
